import View from "../framework/view";
import Server from "../server";
import change_password_template from "../../pugc/change-password";
import {formToJson} from "../misc/utils";
import {ChangePassword} from "../bo/change_password";
import {GotoHomeNotification} from "./talc";
import Alerts from "../misc/alerts";

export class ChangePasswordView extends View {

    static classname = "change-password-view";

    private readonly server = Server.instance();

    private readonly userId?: number;
    private readonly isReset? : boolean;
    private readonly isNew: boolean;

    constructor(userId?: number, isReset?: boolean, isNew?: boolean) {
        super(ChangePasswordView.classname);
        this.userId = userId;
        this.isReset = isReset;
        this.isNew = isNew ? true : false;
    }

    protected render0(): JQuery<HTMLElement> {
        const data = {
            isReset: this.isReset || this.userId,
            isNew: this.isNew
        };
        const out = this.pug(change_password_template, data);

        // @ts-ignore jquery-validation
        out.find('.change-password-form').validate();

        return out;
    }

    changePassword() {
        const form = this.elt().find("form.change-password-form");

        // @ts-ignore
        if (! form.valid()) {
            return;
        }

        const data0 : any = {};
        formToJson(form, data0);

        const data : ChangePassword = {
            currentPassword: data0["currentPassword"],
            newPassword: data0["newPassword"]
        };
        if (this.userId) {
            data.userId = +this.userId;
        }

        this.server.changePassword(data)
            .then(() => {
                Alerts.alert({
                    message: "Password changed",
                    callback: () => {
                        const home = new GotoHomeNotification();
                        this.notify(home);
                    }
                });
            });
    }
}

View.on("." + ChangePasswordView.classname,
    "click",
    "button.change-password",
    function(that: ChangePasswordView, event, elt) {
        event.preventDefault();
        that.changePassword();
    });
